/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
class r{constructor(r=1/0,t=-1/0){this.near=r,this.far=t}set(r,t){this.near=r,this.far=t}union(r){null!=r&&(this.near=Math.min(this.near,r.near),this.far=Math.max(this.far,r.far))}within(r){return this.near<=r&&r<=this.far}}r.zero=new r(0,0);export{r as DepthRange};
